import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Card } from './ui/card';
import { Crown, ListChecks } from 'lucide-react';
import SAR from './SAR';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const fmt = (n) => Number(n || 0).toLocaleString('en-US', { maximumFractionDigits: 2 });

export const TopOptionCard = ({ mine = false }) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    axios.get(`${API_URL}/api/analytics/branch/top-option`).then((r) => setData(r.data)).catch(() => setData(null));
  }, []);

  if (!data?.top) return null;
  const { top, runner_up: runner } = data;
  return (
    <Card className="p-5 border-amber-200 bg-gradient-to-l from-amber-50 to-white shadow-sm" data-testid="top-option-card">
      <div className="flex items-start gap-4">
        <div className="h-12 w-12 rounded-xl bg-amber-100 flex items-center justify-center shrink-0">
          <Crown className="h-6 w-6 text-amber-600" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-xs font-bold text-amber-700">{mine ? 'صنفك الأكثر مبيعاً هذا الشهر' : 'الصنف الأكثر مبيعاً هذا الشهر'}</p>
          <p className="text-xl font-black text-foreground mt-1 truncate" data-testid="top-option-label">{top.label}</p>
          <p className="text-xs text-foreground/60 truncate">{top.product_name}</p>
          <div className="flex flex-wrap gap-2 mt-3 text-xs">
            <span className="px-2 py-1 rounded-md bg-white border border-border font-bold" data-testid="top-option-qty">
              الكمية: <span className="font-numbers">{top.quantity}</span>
            </span>
            <span className="px-2 py-1 rounded-md bg-white border border-border font-bold">
              العمليات: <span className="font-numbers">{top.transactions}</span>
            </span>
            <span className="px-2 py-1 rounded-md bg-emerald-50 text-emerald-700 border border-emerald-200 font-bold" data-testid="top-option-total">
              <span className="font-numbers">{fmt(top.total)}</span> <SAR />
            </span>
          </div>
          {runner && (
            <p className="text-[11px] text-foreground/55 mt-2 flex items-center gap-1" data-testid="top-option-runner">
              <ListChecks className="h-3 w-3" /> يليه: {runner.label} ({runner.quantity})
            </p>
          )}
        </div>
      </div>
    </Card>
  );
};
